import React from "react";

function Spacer({ size = "lg" }) {
  return (
    <div className={`section-spacer section-spacer-${size}`} />
  );
}

export default Spacer;